import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { MaskedLine } from "../components/Reveal";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-screen bg-graphite text-white blueprint-grid flex items-center">
      <Seo title="Page Not Found | NOOR Design & Build" description="The page you are looking for could not be found." path="/404" />
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-32">
        <p className="font-mono text-xs tracking-[0.35em] uppercase text-ember">[ Error 404 ]</p>
        <h1 className="font-display font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter mt-6">
          <MaskedLine delay={0.1}>{"This page isn\u2019t"}</MaskedLine>
          <MaskedLine delay={0.25}>{"on the drawings."}</MaskedLine>
        </h1>
        <p className="text-white/55 leading-relaxed mt-8 max-w-md">
          The page you are looking for may have moved or never existed. Let us point you back to solid ground.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 mt-10">
          <Link to="/" data-testid="not-found-home-link" className="inline-flex items-center justify-center bg-ember hover:bg-emberdark text-white font-semibold tracking-wide px-8 py-4 text-sm transition-colors duration-300">
            Back to Home
          </Link>
          <Link to="/request-a-consultation" data-testid="not-found-consultation-link" className="inline-flex items-center justify-center border border-white/25 hover:border-white px-8 py-4 text-sm transition-colors duration-300">
            Request a Consultation
          </Link>
        </div>
      </div>
    </div>
  );
}
